import React from 'react';
import styles from '../style/style.scss';
import LogoFW from '../components/LogoFW';

export function ProductNotFound() {
  return (
    <div className={styles.fwcontainer} style={{ zIndex: '9999' }}>
      <div className={styles.verticalCenter}>
        <LogoFW />
        <div className="mb-5" />
        <h1 className="display-1 text-center">Nie znaleziono produktu</h1>
      </div>
    </div>
  );
}
